import PageLang from '../../utils/page-lang';
import Popup from '../../utils/popup';

class TerminMobile {
    constructor() {
        this._terminSetting = {
            dataDo: null,
            dataOd: null,
            idKategorii: null
        };

        this._activeLanguage = 'pl';
        this._eventCategories = kategorieWydarzenTwon;
        this._activeCategoryName = 'wszystkie';
        this._activeMonth = null;
        this.selectedCategory = $('#categories-select option.selected');
    }

    get terminSetting() {
        return this._terminSetting;
    }

    set terminSetting(obj) {
        Object.assign(this._terminSetting, obj);
        this.getTerms();
    }

    get activeLanguage() {
        return this._activeLanguage;
    }

    set activeLanguage(value) {
        this._activeLanguage = value;
    }

    get eventCategories() {
        return this._eventCategories;
    }

    set eventCategories(value) {
        this._eventCategories = value;
        this.setTermParams();
    }

    get activeCategoryName() {
        return this._activeCategoryName;
    }

    set activeCategoryName(value) {
        this._activeCategoryName = value;
    }

    get activeMonth() {
        return this._activeMonth;
    }

    set activeMonth(value) {
        this._activeMonth = value;
    }

    events() {
        const _this = this;

        $(document).on('change', '#categories-select', function() {
            _this.initPreloader();

            _this.terminSetting = {
                idKategorii: $(this).val()
            };

            _this.activeCategoryName = $(this)
                .find(':selected')
                .text()
                .toLowerCase();
            $(this)
                .prev()
                .text(
                    $(this)
                        .find(':selected')
                        .text()
                );
        });

        $(document).on('click', '.js-notify-about-availability', function(event) {
            event.preventDefault();

            let termTwonId = $(this).data('id_terminu_twon');
            let termIksorisId = $(this).data('id_terminu_iksoris');

            _this.checkUser(termIksorisId);
        });
    }

    translate(textSymbol) {
        let messages = {
            _b6bb0dd4b3bf1196cee588553f8fc70c: {
                pl: `Brak terminów w miesiącu ${this.activeMonth} i w kategorii ${
                    this.activeCategoryName
                }.`,
                en: `There are no events on month ${this.activeMonth} and ${
                    this.activeCategoryName
                } category.`
            },
            _63239ba01c76fbdc81999eb5f3e19835: {
                pl: 'Kup bilet',
                en: 'Buy ticket'
            },
            _a0d3a4b322517965b48d242b356e9995: {
                pl: 'Powiadom o dostępności',
                en: 'Notify about availability'
            },
            _cd5f339b37628e891e67682909ae3c2d: {
                pl: 'Wszystkie',
                en: 'All'
            },
            _0: {
                pl: 'Niedziela',
                en: 'Sunday'
            },
            _1: {
                pl: 'Poniedziałek',
                en: 'Monday'
            },
            _2: {
                pl: 'Wtorek',
                en: 'Tuesday'
            },
            _3: {
                pl: 'Środa',
                en: 'Wednesday'
            },
            _4: {
                pl: 'Czwartek',
                en: 'Thursday'
            },
            _5: {
                pl: 'Piątek',
                en: 'Friday'
            },
            _6: {
                pl: 'Sobota',
                en: 'Saturday'
            },
            _0a740deb2915b39529419dad31b652da: {
                pl: 'Spektakl odwołany',
                en: 'Performance canceled'
            },
            _4c077133955af7a510f3641823bcaa79: {
                pl: 'Premiera',
                en: 'Premiere'
            },
            _cf974173922c77601887f4333f2ff025: {
                pl: 'Tytuł sezonu',
                en: 'Season title'
            },
            _8471fb6f99545e1b1a4eb0e1b0e02c70: {
                pl: 'Zamknięty',
                en: 'Zamknięty'
            },
            brak_miejsc: {
                pl: 'Brak miejsc',
                en: 'Sold out'
            },
            termin_niedostepny: {
                pl: 'Termin niedostępny',
                en: 'Term unavailable'
            },
            email_label: {
                pl: 'ADRES E-MAIL',
                en: 'E-MAIL ADDRESS'
            }
        };

        if (messages[textSymbol] && messages[textSymbol][this.activeLanguage]) {
            return messages[textSymbol][this.activeLanguage];
        } else {
            return textSymbol;
        }
    }

    setSiteLang() {
        const _this = this;
        let langSymbol = PageLang.get();

        if (langSymbol) {
            langSymbol = langSymbol.toLowerCase();
            if ($.inArray(langSymbol, [
                'pl',
                'en'
            ]) !== -1) {
                _this.activeLanguage = langSymbol;
            }
        }
    }

    getDataDo() {
        return `${this.getYear()}-${
            this.getMonth() < 10 ? '0' + this.getMonth() : this.getMonth()
        }-${this.getDays()}`;
    }

    getDataOd() {
        return `${this.getYear()}-${
            this.getMonth() < 10 ? '0' + this.getMonth() : this.getMonth()
        }-01`;
    }

    getIdKategorii() {
        if (this.selectedCategory.length > 0) {
            return this.selectedCategory.val();
        } else {
            return 0;
        }
    }

    getDays() {
        return $('.category-list-months div.selected span').attr(
            'data-dni-w-miesiacu'
        );
    }

    getMonth() {
        return $('.category-list-months div.selected span').attr('data-miesiac');
    }

    getMonthName() {
        return $('.category-list-months div.selected span').text();
    }

    getYear() {
        return $('.category-list-months div.selected span').attr('data-rok');
    }

    setTermParams() {
        this.terminSetting = {
            dataDo: this.getDataDo(),
            dataOd: this.getDataOd(),
            idKategorii: this.getIdKategorii()
        };

        this.activeMonth = this.getMonthName();
    }

    setSeasonsSlider() {
        const element = $('#category-list-seasons');
        const selectedSlide = element.find('.selected');

        element.slick({
            infinite: false,
            initialSlide: selectedSlide.index(),
            nextArrow: '<span class="icon icon_next slick-next"></span>',
            prevArrow: '<span class="icon icon_prev slick-prev"></span>'
        });

        element.on('afterChange', function(event, slick, index) {
            window.location = $(slick.$slides.get(index))
                .find('span')
                .attr('data-url');
        });
    }

    setMonthsSlider() {
        const _this = this;
        const element = $('#category-list-months');
        let selectedSlide = element.find('.category-list-month.selected');
        if(selectedSlide.length === 0) {
            selectedSlide = $($('.category-list-month')[0]);
            selectedSlide.addClass('selected');
            
        }
        console.log('selected slide length: ', selectedSlide.length);
        let activeSlideIndex = 0;

        element.slick({
            infinite: false,
            initialSlide: selectedSlide.index(),
            nextArrow: '<span class="icon icon_next slick-next"></span>',
            prevArrow: '<span class="icon icon_prev slick-prev"></span>'
        });

        element.on('beforeChange', function() {
            _this.initPreloader();
        });

        element.on('afterChange', function(event, slick, index) {
            let month = $('.category-list-month');

            // Ustawienie aktualnego miesiąca
            _this.activeMonth = slick.$slides.get(index).innerText.toLowerCase();

            // Blokowanie przesyłania żądania Ajax w przypadku pierwszego i ostatniego miesiąca.
            if (index > activeSlideIndex) {
                activeSlideIndex = index;
            } else if (index < activeSlideIndex) {
                activeSlideIndex = index;
            } else {
                return false;
            }

            month
                .removeClass('selected')
                .eq(index)
                .addClass('selected');

            _this.terminSetting = {
                dataDo: _this.getDataDo(),
                dataOd: _this.getDataOd()
            };
        });
    }

    // getCategories() {
    //     const _this = this;
    //
    //     $.ajax({
    //         url: '/rezerwacja/termin.html',
    //         method: 'get',
    //         data: {
    //             json: true,
    //             ajax_action: 'pobierz_kategorie_twon'
    //         },
    //         success: function (result) {
    //             if (result && result.status === 'complete') {
    //                 _this.eventCategories = result.data;
    //                 _this.writeCategories();
    //             } else {
    //                 console.error(result);
    //             }
    //         },
    //         error: function (xhr, status, error) {
    //             console.error(status);
    //             console.error(error);
    //         }
    //     });
    // }

    // writeCategories() {
    //     let html = `<option value="0">${this.translate(
    //         '_cd5f339b37628e891e67682909ae3c2d'
    //     )}</option>`;
    //
    //     $.each(this.eventCategories, function (index, value) {
    //         html += `<option value="${value.id}">${value.nazwa}</option>`;
    //     });
    //
    //     $('#categories-select').append(html);
    // }

    getTerms() {
        const _this = this;

        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'pobierz_terminy',
                data_od: _this.terminSetting.dataOd,
                data_do: _this.terminSetting.dataDo,
                id_kategorii: _this.terminSetting.idKategorii,
                pogrupujPoDacie: true
            },
            success: function(result) {
                _this.writeTerms(result.data);
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    writeTerms(terms) {
        if (terms.length === 0) {
            $('#events-notification')
                .removeClass('d-none')
                .html(`${this.translate('_b6bb0dd4b3bf1196cee588553f8fc70c')}`);
            $('#events')
                .removeClass('preloader')
                .html('');
        } else {
            $('#events-notification')
                .addClass('d-none')
                .html('');
            $('#events')
                .removeClass('preloader')
                .html(this.getTermsHTML(terms));
        }
    }

    getTermsHTML(terms) {
        const _this = this;
        let html = '';

        function getEventCategoryName(selectedCategoriesOfEvent) {
            let selectedCategoriesName = [];

            _this.eventCategories.forEach(function(element) {
                let eventCategoryID = parseInt(element.id);
                let eventCategoryName = element.nazwa;

                selectedCategoriesOfEvent.forEach(function(element) {
                    let selectedCategoryOfEventID = parseInt(element);

                    if (selectedCategoryOfEventID === eventCategoryID) {
                        selectedCategoriesName.push(eventCategoryName);
                    }
                });
            });

            return selectedCategoriesName.join().replace(',', ' , ');
        }

        function getDay(date) {
            if (navigator.userAgent.match(/(iPhone|iPod|iPad)/) != null) {
                var dateParts = date.split('-');
                var timePart = '00:01';
                date = dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0] + ' ' + timePart;
            } else {
                date = date.replace(/-/g, ', ');
            }
            var d = new Date(date);
            return d.getDate();
        }

        function getWeekDay(date) {
            if (navigator.userAgent.match(/(iPhone|iPod|iPad)/) != null) {
                var dateParts = date.split('-');
                var timePart = '00:01';
                date = dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0] + ' ' + timePart;
            } else {
                date = date.replace(/-/g, ', ');
            }
            var d = new Date(date);
            return _this.translate('_' + d.getDay());
        }

        function getButton(event) {
            if (event.terminWprzeszlosci) {
                return `<p>${_this.translate('termin_niedostepny')}</p>`;
            } else if (event.idTerminuIksoris) {
                if (event.wolneMiejsca === 0) {
                    return `<p>${_this.translate('brak_miejsc')}</p>
                  <a class="btn btn--brown powiadom-btn js-notify-about-availability" href="#" data-id_terminu_twon="${
                        event.id
                    }" data-id_terminu_iksoris="${
                        event.idTerminuIksoris
                    }">${_this.translate('_a0d3a4b322517965b48d242b356e9995')}</a>`;
                } else {
                    if (event.sprzedazOd.status) {
                        return `<span class="btn btn--black" style="line-height: 1.6; padding: 10px 15px;">${event.sprzedazOd.info}</span>`;
                    } else {
                        return `<a class="btn btn--brown" href="${
                            event.terminUrl
                        }">${_this.translate('_63239ba01c76fbdc81999eb5f3e19835')}</a>`;
                    }
                }
            } else if (event.etykietaPrzycisku !== '') {
                return `<p>${event.etykietaPrzycisku}</p>`;
            } else {
                return `<p>${_this.translate('termin_niedostepny')}</p>`;
            }
        }

        function getBadge(event) {
            let badges = [
                {
                    status: event.infoOdwolany,
                    info: _this.translate('_0a740deb2915b39529419dad31b652da')
                },
                {
                    status: event.infoPremiera,
                    info: _this.translate('_4c077133955af7a510f3641823bcaa79')
                },
                {
                    status: event.infoZamkniety,
                    info: _this.translate('_8471fb6f99545e1b1a4eb0e1b0e02c70')
                }
            ];

            let badgesInfo = '';

            badges.forEach(function(element) {
                if (element.status) {
                    badgesInfo += `<span class="badge">${element.info}</span>`;
                }
            });

            return badgesInfo;
        }

        function getEvent(date, events) {
            let html = '';

            for (let index = 0; index < events.length; index++) {
                const event = events[index];

                html += `<div class="text">
                  <div class="header clearfix">
                    <div class="date">
                      <time datetime="${date}">
                        <span class="day">${getDay(event.dataTerminu)}</span>
                        <span class="weekday">${getWeekDay(
                    event.dataTerminu
                )}</span>
                      </time>
                    </div>
                    <div class="title">
                      <h3><a href="${event.urlWydarzenia}">${
                    event.tytul
                }</a> ${getBadge(event)}</h3>
                      <h4>
                        <span class="hour">${event.godzinaTerminu}</span> /
                        <span class="category">${getEventCategoryName(
                    event.kategorie_id
                )}</span> /
                        <span class="hall">${event.infoMiejsce}</span>
                      </h4>
                      <p>${event.autor}</p>
                    </div>
                  </div>
                  <div class="btns">${getButton(event)}</div>
                </div>`;
            }

            return html;
        }

        $.each(terms, function(key, value) {
            html += `<div class="event" data-day="${key}">${getEvent(
                key,
                value
            )}</div>`;
        });

        return html;
    }

    initPreloader() {
        $('#events-notification')
            .addClass('d-none')
            .html('');
        $('#events')
            .html('')
            .addClass('preloader');
    }

    checkUser(termIksorisId) {
        const that = this;

        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'pobierz_strone_dostepnosc_info'
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let popup = new Popup(
                        '<div class="form__section-header"><strong>' +
                        result.data.stronaBiletyDostepnoscTytul +
                        '</strong></div>' +
                        '<div class="fr-popup__text">' +
                        result.data.stronaBiletyDostepnoscTresc +
                        '</div>' +
                        '<div class="form__row">' +
                        '  <div class="form__col">' +
                        '    <label class="form__label"><strong>' +
                        that.translate('email_label') +
                        '</strong></label>' +
                        '      <input class="form__input notification__email" type="text" value="' +
                        result.data.email +
                        '">' +
                        '  </div>' +
                        '</div>'
                    );
                    //ADRES E-MAIL
                    popup.onSave = function() {
                        that.zapiszDaneDoPowiadomienia(
                            termIksorisId,
                            result.data.kontrahent_id
                        );
                    };
                    popup.showPopup();
                } else {
                    let popup = new Popup(
                        result.message ||
                        'Wystąpił błąd w trakcie sprawdzania danych użytkownika'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                let popup = new Popup(
                    'Wystąpił błąd w trakcie sprawdzania danych użytkownika'
                );
                popup.showPopup();
                console.error(status);
                console.error(error);
            }
        });
    }

    zapiszDaneDoPowiadomienia(termIksorisId, kontrahent_id) {
        const that = this;

        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'zapisz_dane_do_powiadomienia',
                termin_iksoris_id: termIksorisId,
                email: $('.notification__email').val(),
                kontrahent_id: kontrahent_id
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    setTimeout(function() {
                        let popup = new Popup(
                            '<div class="form__section-header"><strong>POWIADOM O DOSTĘPNOŚCI BILETÓW</strong></div>' +
                            '<div class="fr-popup__text">Twój mail dodano do bazy dostępności biletów na spektakl "' +
                            result.data.wydarzenie +
                            '".</div>'
                        );
                        popup.showPopup();
                    }, 500);
                } else {
                    setTimeout(function() {
                        let popup = new Popup(
                            result.message || 'nie udało się zapisać danych'
                        );
                        popup.showPopup();
                    }, 500);
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });

    }

    getMonthDetails(year, month) {
        let that = this;
        // Sprawdzenie poprawności danych wejściowych
        if (typeof year !== 'number' || typeof month !== 'number' || month < 1 || month > 12) {
            throw new Error('Invalid input. Year must be a number, and month must be a number between 1 and 12.');
        }

        // Data rozpoczęcia miesiąca
        const startDate = new Date(year, month - 1, 1, 0, 0, 0);

        // Data zakończenia miesiąca
        const endDate = new Date(year, month, 0, 23, 59, 59);

        // Liczba dni w miesiącu
        const daysInMonth = endDate.getDate();

        return {
            startDate: that.formatDate(startDate),
            endDate: that.formatDate(endDate),
            daysInMth: daysInMonth
        };
    }

    // Funkcja pomocnicza do formatowania daty
    formatDate(date) {
        const pad = (num) => String(num).padStart(2, '0');
        //return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    setInitialMonth() {
        let that = this;

        let monthDetails = that.getMonthDetails(yearToSelect, monthToSelect);
        that.terminSetting.wybranyRok = yearToSelect;
        that.terminSetting.wybranyMiesiac = monthToSelect;
        that.terminSetting.liczbaDniWMiesiacu = monthDetails.daysInMth;
        that.terminSetting.dataOd = monthDetails.startDate;
        that.terminSetting.dataDo = monthDetails.endDate;
        $('.category-list-month.selected').removeClass('selected');
        let mthBlock = $('.category-list-month span[data-miesiac="' + monthToSelect + '"][data-rok="' + yearToSelect + '"]');
        if (mthBlock.length > 0) {
            mthBlock.parent().addClass('selected');
        }
        that.getTerms();
    }

    init() {
        this.events();
        this.setSiteLang();
        this.setInitialMonth();
        this.setSeasonsSlider();
        this.setMonthsSlider();
        //this.getCategories();
    }
}

export default TerminMobile;